// src/AuthScreen.jsx
// Spark login/register screen — wraps shared NarbodicaAuth component.
// Themed with Spark's violet accent and branding.
import NarbodicaAuth from './narb-auth/src/components/NarbodicaAuth.jsx';
import { API_BASE } from './apiConfig';

export default function AuthScreen({ onSuccess, defaultMode = 'login' }) {
  return (
    <div style={{
      minHeight: '100dvh',
      background: 'linear-gradient(135deg, #0f0a1e 0%, #1a0a2e 50%, #0d1117 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px',
      fontFamily: "'Inter', sans-serif",
    }}>
      {/* Ambient glow */}
      <div style={{
        position: 'fixed', top: '20%', left: '50%', transform: 'translateX(-50%)',
        width: 400, height: 400, borderRadius: '50%',
        background: 'radial-gradient(circle, #7c3aed20 0%, transparent 70%)',
        pointerEvents: 'none', zIndex: 0,
      }} />

      <div style={{
        position: 'relative', zIndex: 1,
        width: '100%', maxWidth: 400,
        background: 'rgba(15,10,30,0.85)',
        WebkitBackdropFilter: 'blur(20px)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(124,58,237,0.2)',
        borderRadius: 20,
        padding: '32px 24px',
        boxShadow: '0 32px 80px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.05)',
      }}>
        <NarbodicaAuth
          app="spark"
          appLabel="Spark"
          appTagline="Dating without the paywall"
          accentColor="#7c3aed"
          apiBase={API_BASE}
          onSuccess={onSuccess}
          defaultMode={defaultMode}
          requireDob={true}
          requireGender={true}
          showDisclaimer={false}
        />
      </div>
    </div>
  );
}
